import { Component, EventEmitter, Input, OnDestroy, OnChanges, Output, ViewChild, SimpleChanges, ElementRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

// import { ApplicationUtilsService, InputGewijzigdService } from '../../global_services/application_utils/application_utils.service';
import { ApplicationUtilsService, InputGewijzigdService } from '@util-services';
import { DateHeaderComponent } from '../ecertnl-date-header/ecertnl-date-header.component';
import { EcertBaseBlockComponent } from '../ecertnl-base-block/ecertnl-base-block.component';
import { isEmptyValue } from '@helpers';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CustomAppDateAdapter, CUSTOM_DATE_FORMATS } from './ecertnl-date-adapter';

@Component({
  selector: 'ecert-date',
  templateUrl: './ecertnl-date.component.html',
  styleUrls: ['./ecertnl-date.component.css', '../../app.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    // {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    { provide: DateAdapter, useClass: CustomAppDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'nl' },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
  standalone: false,
})
export class EcertDateComponent extends EcertBaseBlockComponent implements OnChanges, OnDestroy {
  @Input() id: string;
  @Input() dateFormat = 'DD-MM-YYYY';
  @Input() minDate: Date = null;
  @Input() maxDate: Date = null;
  @Input() hideIcon: boolean;
  @Input() foutmeldingSmal = false;

  @Output() dateChange = new EventEmitter<boolean>();
  @Output() rauweInputChange = new EventEmitter<string>();

  protected dateHeader = DateHeaderComponent;

  @ViewChild('input') private input: ElementRef<HTMLInputElement>;

  constructor(appUtils: ApplicationUtilsService, private inputGewijzigdService: InputGewijzigdService) {
    super(appUtils);
  }

  ngOnChanges({ ref_object, property, minDate, maxDate }: SimpleChanges): void {
    if (!isEmptyValue(minDate) && !isEmptyValue(minDate.currentValue)) {
      if (!(minDate.currentValue instanceof Date)) {
        this.minDate = new Date(minDate.currentValue);
        if (typeof minDate.currentValue === 'string' && minDate.currentValue.length <= 10) {
          this.minDate.setHours(0, 0, 0);
        }
      }
    }

    if (!isEmptyValue(maxDate) && !isEmptyValue(maxDate.currentValue)) {
      if (!(maxDate.currentValue instanceof Date)) {
        this.maxDate = new Date(maxDate.currentValue);
      }
      if (typeof maxDate.currentValue === 'string' && maxDate.currentValue.length <= 10) {
        this.maxDate.setHours(0, 0, 0);
      }
    }

    if (!isEmptyValue(ref_object) || !isEmptyValue(property) || !isEmptyValue(minDate) || !isEmptyValue(maxDate)) {
      if (!isEmptyValue(this.ref_object) && !isEmptyValue(this.ref_object[this.property])) {
        this.checkDate(this.ref_object[this.property]);
      }
    }
  }

  ngOnDestroy(): void {
    this.input = null;
  }

  hasErrors(): boolean {
    return this.error;
  }

  leegFoutmelding(): void {
    this.error = false;
  }

  leegVeld(): void {
    this.input.nativeElement.value = null;
  }

  protected showActionIdentifier(): boolean {
    return !isEmptyValue(this.action_identifier) || (isEmptyValue(this.label) && !this.hideLabel);
  }

  protected showIcon(): boolean {
    return isEmptyValue(this.hideIcon) || !this.hideIcon;
  }

  protected onDateChange(event: MatDatepickerInputEvent<Date>, value: string): void {
    this.inputGewijzigd();
    const date = event.value;
    if (value === '') {
      this.error = false;
    } else {
      if (isEmptyValue(date)) {
        this.error = true;
        this.foutmelding = 'MELDINGEN.DATUM_ONJUIST_FORMAAT';
        return;
      }
      this.checkDate(date, value);
    }
/*
    if (
      (this.action_identifier === 'INSPECTIE_AANVRAGEN.DATUM_INSPECTIE' || this.action_identifier === 'GELEIDEBILJET.DATUM_OPGESTELD') &&
      !this.error
    ) {
      // Toon foutmelding dat een waarde moet worden ingevoerd
      // indien het veld 'Datum inspectie' niet is ingevuld
      // EN dit veld is verplicht via verplicht-STA of sector-parameter IS_PLAN_VWA_EBS
      if (
        (isEmptyValue(event.value) || (event as any).value.length == 0) &&
        (this.appUtils.isKolomActieVerplicht('INSPECTIE_AANVRAGEN.DATUM_INSPECTIE') || this.isPlanVwaEbs())
      ) {
        this.error = true;
        this.foutmelding = 'Voer een waarde in';
      }
    }
*/
    this.dateChange.emit(this.error);
  }

/*
  isPlanVwaEbs() {
    let value = this.appUtils.getSectorParameter('INSP_PLAN_VWA_EBS') as boolean;
    value = value == null ? false : value;
    return value;
  }
*/

  protected inputGewijzigd(): void {
    this.inputGewijzigdService.inputGewijzigd(this.id);
  }

  // protected rauweInput(event: InputEvent) {
  protected rauweInput(event: Event) {
    const rauweInput = (event.target as HTMLInputElement).value;
    this.rauweInputChange.emit(rauweInput);
  }

  private checkDate(date: string | Date, value = null): void {
    this.error = false;
    this.foutmelding = '';
    if (this._disabled) {
      return;
    }
    if (typeof date === 'string') {
      date = this.string2date(date);
    }
    if (date === null) {
      date = this.string2date(value);
    }
    if (date !== null) {
      const dateTime = date.getTime();
      if (isNaN(dateTime)) {
        return;
      }

      if (!isEmptyValue(this.minDate)) {
        const minDateTime = this.minDate.getTime();
        if (!isNaN(minDateTime) && dateTime < minDateTime) {
          this.error = true;
          this.foutmelding = 'MELDINGEN.DATUM_KLEINER_DAN_MINIMUM';
          return;
        }
      }

      if (!isEmptyValue(this.maxDate)) {
        const maxDateTime = this.maxDate.getTime();
        if (!isNaN(maxDateTime) && maxDateTime < dateTime) {
          this.error = true;
          this.foutmelding = 'MELDINGEN.DATUM_GROTER_DAN_MAXIMUM';
          return;
        }
      }
    }
  }

  private string2date(date: Date | string): Date {
    if (date === null) {
      return null;
    }

    if (typeof date === 'string') {
      if ((date.match(/-/g) || []).length !== 2) {
        return null;
      }

      let result = new Date(date);
      if (!isNaN(result.getTime())) {
        return result;
      }

      const str = date.split('-');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const day = Number(str[0]);
      result = new Date(Date.UTC(year, month, day));
      if (!isNaN(result.getTime())) {
        return result;
      }

      return null;
    }

    if (!isNaN(date.getTime())) {
      return date;
    }

    return null;
  }
}
